// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__F+35V","filters_close":"FiltersBlock_filters_close__XBziy"};